import React from "react";
import MiCompAPI from "./../../util/api";
import {
  Form,
  Row,
  Col,
  Layout,
  Select,
  Button,Icon
} from "antd";
const { Content } = Layout;
const { Option } = Select;
class MI extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      title: "Business Search",
      carriers: [], months: [], years: [], usstates: [], entity: [],
      filedata: null,
      userNpn: "",
      isAcceptedTermsandConditions:false,
      isDontShowAgainTermsandConditions:false,
      lob: [],
      userDefaults: null
    };
    this.api = new MiCompAPI(this.props.userPermandMasters);
  }
  componentWillMount = () => {
    this.getClientMasters();
    this.getUserDefaults();
  }
  getUserDefaults = () => {

    this.api.invoke(
      "GetUserDefaults",
      "get",
      (data, success) => {
        if (success) {
          var defaultData = data.data;
          this.setState({
            userNpn: defaultData.userNpn,
            userDefaults: defaultData,
            isAcceptedTermsandConditions:defaultData.isAcceptedTermsandConditions,
            isDontShowAgainTermsandConditions:defaultData.isDontShowAgainTermsandConditions,
          });

        }
      }

    );
  }
  getClientMasters() {
    const { decodedToken } = this.props.userPermandMasters;
    var role = decodedToken.UserRoleName;
    this.api.invoke(
      "GetMasters",
      "post",
      (data, success) => {
        if (success) {

          this.setState({
            entity: data.entity,
            months: data.months,
            years: data.years,
            lob: data.lobs,

          });
          this.GetStatebyLoAState(data.lobs[0].name,1);
          if (role === "carrier") {
            this.setState({usstates:data.states});
            this.props.parentCallBack(this.state);
          }
         

        }
      },
      ["ENTITY", "MTH", "YR", "LOB","STATE"]
    );
  }


  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.props.submitHandler({ ...values });
      }
    });
  }
  GetStatebyLoAState = (e,entry) => {
    const { decodedToken } = this.props.userPermandMasters;
    var role = decodedToken.UserRoleName;
   if (role !== "carrier"){
    this.api.invoke(
      "GetStatebyLoAState/" + e,
      "get",
      (data, success) => {
        if (success) {
          this.setState({
            usstates: data.data
          });
          if(entry===1)
          this.props.parentCallBack(this.state);
        }
      }
    );
   }

  }
  render() {
    const { getFieldDecorator } = this.props.form;
    return (
      <div className="mi_main" style={{padding:"0px"}}>
        <Content>
          <div style={{background:'white',padding: '25px 5px',borderRadius:'6px'}}>
          {/* <Card type="inner"> */}
          <Row>
            <Form
              onSubmit={this.handleSubmit}
              layout="vertical"
              hideRequiredMark
            >
              <Row span={24}>

                <Col md={8} sm={24}>
                  <Form.Item>
                    <fieldset className="mi_input_pop">
                      <legend className="legend-font">LOA </legend>
                      {getFieldDecorator('strLOADesc', {
                        initialValue:this.state.lob.length>0?this.state.lob[0].name:undefined,
                        rules: [{ required: false, message: 'Please select LOA' }],
                      })(<Select suffixIcon={<Icon style={{transform:'rotate(90deg)'}} type="double-right" />}
                        showSearch={true}
                        optionFilterProp="children"
                        onChange={this.GetStatebyLoAState}
                        filterOption={(input, option) =>
                          option.props.children
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        } className="mi_input" placeholder="Please Select LOA" >
                        {this.state.lob.map(tag => <Option value={tag.name} key={tag.id}>{tag.name}</Option>)}
                      </Select>)}
                    </fieldset>
                  </Form.Item>
                </Col>
                <Col md={8} sm={24}>
                  <Form.Item>
                    <fieldset className="mi_input_pop">
                      <legend className="legend-font">State</legend>
                      {getFieldDecorator('iStateId', {
                        initialValue:this.state.usstates.length>0?this.state.usstates[0].name:undefined,
                        rules: [{ required: false, message: 'Please select State' }],
                      })(<Select suffixIcon={<Icon style={{transform:'rotate(90deg)'}} type="double-right" />}
                        showSearch={true}
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                          option.props.children
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        } className="mi_input" placeholder="Please Select"  >
                        {this.state.usstates.map(tag => <Option value={tag.name} key={tag.name}>{tag.name}</Option>)}
                      </Select>)}
                    </fieldset>
                  </Form.Item>
                </Col>
                <Col md={8} sm={24}>
                  <Form.Item>
                    <fieldset className="mi_input_pop">
                      <legend className="legend-font">Entity</legend>
                      {getFieldDecorator('strEntityTypeDesc', {
                        initialValue:this.state.entity.length>0?this.state.entity[0].name:undefined,
                        rules: [{ required: false, message: 'Please select Entity' }],
                      },
                      )(<Select suffixIcon={<Icon style={{transform:'rotate(90deg)'}} type="double-right" />}
                        showSearch={true}
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                          option.props.children
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        } className="mi_input" placeholder="Please Select">
                        {this.state.entity.map(tag => <Option value={tag.name} key={tag.id}>{tag.name}</Option>)}
                      </Select>)}
                    </fieldset>
                  </Form.Item>
                </Col>

              </Row>

              <Row>
                <Col span={5} style={{paddingTop:'22px'}}>
                  <Form.Item>
                    <Button className="submit-button" htmlType="submit" type="primary" style={{marginLeft:'18px'}}>
                      Search
                    </Button>
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </Row>
          {/* </Card> */}</div>
        </Content>
      </div>
    )
  }
}
const SearchBusinessForm = Form.create()(MI);
export default SearchBusinessForm;